import { isAiChatEntryPage, type AiCapabilityPage } from "./schema.js";
import { COL_DEADLINE } from "./pages/col-deadline.js";
import { COL_EQUAL } from "./pages/col-equal.js";
import { COL_RECURRING } from "./pages/col-recurring.js";
import { DEBT_REMIND } from "./pages/debt-remind.js";
import { DUE_CLAIM_WITHDRAW } from "./pages/due-claim-withdraw.js";
import { EXP_F_EQUAL } from "./pages/exp-f-equal.js";
import { EXP_F_NOALLOC } from "./pages/exp-f-noalloc.js";
import { EXP_F_ADVANCE } from "./pages/exp-f-advance.js";
import { GROUP_BANK_ACCOUNT } from "./pages/group-bank-account.js";
import { REGISTRY_HELP_PAGE } from "./pages/help-from-registry.js";
import { INC_RECORD } from "./pages/inc-record.js";
import { ONB_ADD_MEMBERS } from "./pages/onb-add-members.js";
import { ONB_CREATE_FUND } from "./pages/onb-create-fund.js";
import { ONB_CREATE_GROUP } from "./pages/onb-create-group.js";
// Hằng choices của trang bound đầu tiên — binding api (0031) khoá ánh xạ nhãn→code theo đúng tập này (typecheck đỏ khi lệch).
export { ONB_CREATE_GROUP_TYPE_CHOICES } from "./pages/onb-create-group.js";
import { PAY_CONFIRM_DECIDE } from "./pages/pay-confirm-decide.js";
import { PAY_REPORT } from "./pages/pay-report.js";
import { READ_COLLECTIONS } from "./pages/read-collections.js";
import { READ_FUND_MONEY } from "./pages/read-fund-money.js";
import { READ_PEOPLE_MINE } from "./pages/read-people-mine.js";
// US-AIV2-0110 S21 (@UC0269 · QĐ PO 26/09 câu F): "ai nợ ai" — trang đọc chỉ trong trợ lý, `draft` tới lượt thu eval.
import { READ_DEBTS } from "./pages/read-debts.js";
import { RECORD_PAID } from "./pages/record-paid.js";
import { SHARE_TRANSPARENCY } from "./pages/share-transparency.js";
// — US-AIV2-0049 (@UC0216): 29 trang `redirect` — 4 viết tay (@UC0210 @UC0211 @UC0214 @UC0215) + 25 trang ngắn cho phần việc T3 còn lại.
import { ACCT_DELETE } from "./pages/acct-delete.js";
import { ACCT_LEAVE_GROUP } from "./pages/acct-leave-group.js";
import { ACCT_LOGIN_LINKS } from "./pages/acct-login-links.js";
import { ACCT_NOTIFY } from "./pages/acct-notify.js";
import { ACCT_PROFILE } from "./pages/acct-profile.js";
import { COL_CLOSE_REOPEN } from "./pages/col-close-reopen.js";
import { COL_BILL } from "./pages/col-bill.js";
import { COL_EDIT } from "./pages/col-edit.js";
import { COL_SCHEDULE_MANAGE } from "./pages/col-schedule-manage.js";
import { EXP_APPROVE } from "./pages/exp-approve.js";
import { PAY_ON_BEHALF } from "./pages/pay-on-behalf.js";
import { REPORT_EXPORT } from "./pages/report-export.js";
import { EXP_VOTE } from "./pages/exp-vote.js";
import { FIX_MISTAKE } from "./pages/fix-mistake.js";
import { GRP_ACTIVITY } from "./pages/grp-activity.js";
import { GRP_ARCHIVE_DELETE } from "./pages/grp-archive-delete.js";
import { GRP_BANK_QR } from "./pages/grp-bank-qr.js";
import { GRP_EDIT_INFO } from "./pages/grp-edit-info.js";
import { GRP_JOIN_REQUEST } from "./pages/grp-join-request.js";
import { GRP_MEMBER_REMOVE } from "./pages/grp-member-remove.js";
import { GRP_MEMBER_ROLE } from "./pages/grp-member-role.js";
import { GRP_OPEN } from "./pages/grp-open.js";
import { JOIN_REQUEST_MINE } from "./pages/join-request-mine.js";
import { GRP_OWNERSHIP } from "./pages/grp-ownership.js";
import { IDENTITY_LINK } from "./pages/identity-link.js";
import { INVITE_ACCEPT } from "./pages/invite-accept.js";
import { INVITE_LINK_MANAGE } from "./pages/invite-link-manage.js";
import { MEMBER_SCAN } from "./pages/member-scan.js";
import { MEMBER_STATUS_LINK } from "./pages/member-status-link.js";
import { NAME_IN_GROUP } from "./pages/name-in-group.js";
import { MEMBER_BIRTH_DATE } from "./pages/member-birth-date.js";
import { NOTIF_INBOX } from "./pages/notif-inbox.js";
import { REPORT_VIEW } from "./pages/report-view.js";
import { TX_LABEL } from "./pages/tx-label.js";


/**
 * 🔴 US-AIV2-0011 (@UC0150) — SỔ NĂNG LỰC: NGUỒN DUY NHẤT của mọi việc trợ lý biết làm.
 *
 * Đây là hằng mà gate `scripts/gen-ai-registry.mjs --check` coi là **Sổ**: mọi `export const *_REGISTRY`
 * / `*_CATALOG` khai tool/usecase/thẻ/câu ví dụ ở NGOÀI thư mục `packages/domain/src/ai/registry/` là
 * đỏ kèm đường dẫn. v1 chết vì 8 registry rải ở 8 chỗ (ADR-0009 bối cảnh); v2 có đúng một.
 *
 * Mỗi trang một file `./pages/<id>.ts` — nội dung là DỮ LIỆU `satisfies AiCapabilityPage`, không hàm. Bộ sinh
 * `docs/generated/ai-registry.md` đọc mảng này qua `validateAiRegistry` — trang sai hình không vào bảng, và bảng là
 * thứ PO đọc để trả lời "AI làm được gì" (README epic §4 cam kết 7).
 *
 * US-AIV2-0049 (17/09/2026): thêm **29 trang `redirect`** ⇒ Sổ là **BẢN ĐỒ ĐẦY ĐỦ** (`@UC0216`): mọi cửa `apps/mobile` đang gọi
 * đều có đúng một trang chịu trách nhiệm (`page.endpoints`), thay hẳn bảng tay `docs/ai-coverage-map.json`. Trang redirect ở
 * `status: bound` vì với tier này "nối được với thứ chạy thật" nghĩa là `screen` trỏ một route CÓ THẬT của `apps/mobile` —
 * gate `assert-ai-coverage.sh` tự khám phá bảng route và đỏ nếu không.
 *
 * US-AIV2-0013 (16/09/2026): nạp **19 trang chat MVP** ở `status: draft` — 13 ghi (@UC0192–@UC0204) · SHARE-TRANSPARENCY
 * (T1, @UC0212) · 3 nhóm đọc (@UC0205–@UC0207) · HELP (@UC0208) · GROUP-BANK-ACCOUNT (@UC0213). Hồ sơ nói "20": con số tay
 * đếm thêm trang cha `COL-WRITE`/`EXP-WRITE` — KHÔNG là trang trong v2 (kẹt giữa hai trang = `ambiguities` của Phiếu,
 * 0012; dựng trang cha là cơ chế thứ hai). Thứ tự dưới đây = thứ tự nhóm trong `USECASES-AIV2.md`, không phải ưu tiên.
 */
export const AI_CAPABILITY_REGISTRY: readonly AiCapabilityPage[] = Object.freeze([
  // — onboarding (T1) —
  ONB_CREATE_GROUP,
  ONB_CREATE_FUND,
  ONB_ADD_MEMBERS,
  // — đợt thu (T2) —
  COL_EQUAL,
  COL_RECURRING,
  COL_DEADLINE,
  // — tiền vào: khai · rút khai · đối chiếu · ghi nhận · nhắc (T2 / T1) —
  PAY_REPORT,
  DUE_CLAIM_WITHDRAW,
  PAY_CONFIRM_DECIDE,
  RECORD_PAID,
  DEBT_REMIND,
  // — chi & thu ngoài đợt (T2) —
  EXP_F_NOALLOC,
  // US-AIV2-0113 ADVANCE-SHORTFALL (@UC0358 · QĐ PO 30/09 B): quỹ trả phần có, người ứng bù phần thiếu, quỹ nợ lại.
  EXP_F_ADVANCE,
  EXP_F_EQUAL,
  INC_RECORD,
  // — đọc —
  // 0055: `EXP_APPROVE` khai TRONG khối chat. (Từ AI-MENU-A thứ tự khai Sổ KHÔNG còn quyết nút menu — catalog
  // `menu-catalog.ts` quyết; trước đó trang khai sau khối `redirect` rơi khỏi menu theo trần.)
  EXP_APPROVE,
  PAY_ON_BEHALF,
  REPORT_EXPORT,
  READ_FUND_MONEY,
  READ_COLLECTIONS,
  READ_PEOPLE_MINE,
  READ_DEBTS,
  REGISTRY_HELP_PAGE,
  GROUP_BANK_ACCOUNT,
  // — redirect (T3): chỉ nút mở màn hình, 0 bút toán (US-AIV2-0049 · @UC0216) —
  // 4 trang viết tay: đủ ví dụ như trang chat, mỗi trang một quyết định đã ghi trong chính file trang.
  FIX_MISTAKE,
  COL_CLOSE_REOPEN,
  INVITE_ACCEPT,
  IDENTITY_LINK,
  // US-AIV2-0112 H11 (@UC0212): SHARE_TRANSPARENCY rời khối chat (T1 draft) sang redirect — khai TRONG khối redirect (không có dòng catalog
  // menu ⇒ không nút menu; trước AI-MENU-A thứ tự này còn quyết suất khám phá).
  SHARE_TRANSPARENCY,
  // đợt thu & lịch thu
  COL_BILL,
  COL_EDIT,
  COL_SCHEDULE_MANAGE,
  // nhóm: hồ sơ · tiền vào · vòng đời · quyền
  GRP_EDIT_INFO,
  GRP_BANK_QR,
  GRP_ARCHIVE_DELETE,
  GRP_OWNERSHIP,
  GRP_MEMBER_ROLE,
  GRP_MEMBER_REMOVE,
  GRP_JOIN_REQUEST,
  INVITE_LINK_MANAGE,
  MEMBER_STATUS_LINK,
  MEMBER_SCAN,
  NAME_IN_GROUP,
  MEMBER_BIRTH_DATE,
  // chi: biểu quyết (duyệt/từ chối nay là trang CHAT `EXP_APPROVE` ở khối T2 — 0055, QĐ PO 17/09 #1)
  EXP_VOTE,
  // sổ & báo cáo
  TX_LABEL,
  GRP_ACTIVITY,
  GRP_OPEN,
  JOIN_REQUEST_MINE,
  REPORT_VIEW,
  NOTIF_INBOX,
  // cụm tài khoản (QĐ PO 17/09 mục 12)
  ACCT_PROFILE,
  ACCT_NOTIFY,
  ACCT_LOGIN_LINKS,
  ACCT_LEAVE_GROUP,
  ACCT_DELETE,
]);

/** Tra một trang theo id — `undefined` khi không có; KHÔNG đoán trang gần giống (Người phiên dịch mới được hỏi A/B). */
export function findAiPage(id: string, registry: readonly AiCapabilityPage[] = AI_CAPABILITY_REGISTRY): AiCapabilityPage | undefined {
  return registry.find((p) => p.id === id);
}

/**
 * 🔴 US-AIV2-0076 (@UC0157 @UC0208) — **"VIỆC LÀM ĐƯỢC TRONG TRÒ CHUYỆN"**: vị-từ DUY NHẤT, ba chỗ cùng đọc.
 *
 * Hai vế, và cả hai đã có án lệ viết thành văn ở `registry-read-help.binding.ts` (review #874, 19/09):
 *  · `status !== "draft"` — trang nháp chưa chạy được, *"kể nó ra là hứa một nút không bấm được"*;
 *  · `tier !== "redirect"` — trang redirect **chỉ mở màn hình**, không phải một việc trợ lý LÀM trong trò chuyện.
 *
 * Trước task này vị-từ ấy sống ở **một** chỗ (binding `HELP-FROM-REGISTRY`) và trần menu **không** biết tới nó — nên câu
 * *"mình làm được những việc này"* và **bãi nút ngay dưới câu đó** đếm theo hai luật khác nhau. Gộp về một hàm là câu trả
 * lời cho đúng điều `render-turn.ts` cảnh báo: *"mọi luật về chip chỉ được sống ở MỘT chỗ, nếu không thì trần sẽ trôi khỏi
 * nhau"*. Hộ khẩu: xem khối ngay dưới (bốn chỗ, và một vị-từ GẦN GIỐNG cố ý để riêng).
 */
/**
 * 🔴 **PHẠM VI — đây là vị-từ của SỔ, KHÔNG phải của MÔI TRƯỜNG** (reviewer PR #882, M-5; bản đầu khai "vị-từ DUY NHẤT"
 * rộng hơn code). Vị-từ quyết *"trang có chạy được ở đây không"* lúc runtime là `AiCapabilityGateService.isRunnable`, và nó
 * có **thêm một vế mà domain không thể biết**: `env === "production" && status !== "live" ⇒ false`.
 *
 * Hệ quả đo được, có TỪ TRƯỚC PR này (không phải hồi quy, nhưng đừng để câu "duy nhất" che mất): ở production,
 * `HELP-FROM-REGISTRY` kể ra cả trang `bound` **chưa `live`** ⇒ chưa bấm được — đúng thất bại mà chính vị-từ này nói nó
 * ngăn. Domain thuần thì không đọc `NODE_ENV`; muốn đóng vế đó thì phải để tầng api truyền tập trang ĐÃ LỌC vào binding
 * (cùng họ `US-AIV2-0075`), không phải thêm một vế môi trường vào đây.
 *
 * Hộ khẩu: catalog menu (`menu-catalog.invariants.spec.ts` — mọi trang chat có đúng một dòng) · `HELP-FROM-REGISTRY` · `menuChatPagesCut`
 * (chuông «không tới được» của menu) · bất biến `menu-chip-cap.invariants.spec.ts`. `scripts/gen-ai-coverage.mjs` có một vị-từ GẦN GIỐNG nhưng
 * **không loại `draft`** — cố ý để riêng (nó đo phủ, không đo "bày cho người dùng"); đừng gộp mù.
 */
export function isAiChatRunnablePage(page: AiCapabilityPage): boolean {
  // US-AIV2-0113 ADVANCE-SHORTFALL: trang chỉ-mở-bằng-nút không phải "việc gõ được trong trò chuyện" — không vào menu/trợ giúp/trần chip.
  return page.status !== "draft" && page.tier !== "redirect" && isAiChatEntryPage(page);
}

